module.exports = __webpack_public_path__ + "img/picture_statute.752dd0fd.jpg";